import Data from "../../data/hiring_organizations.json";
import HiringOrganizationLayout from "./components/HiringOrganizationLayout";
import OwlCarousel from "react-owl-carousel";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

// import required modules
import { Autoplay } from "swiper/modules";

function HiringOrganizations() {
  return (
    <div className="hiring-organization my-3 container text-center">
      {/* <div className=" d-flex justify-content-center"> */}
      {/* </div> */}
      <div className="row mt-4 px-1 position-relative justify-content-center">
        <div className="head col-lg-2 col-md-4 col-7 fs-6 fw-bold position-absolute px-4 py-2 rounded text-white section-tag text-center">
          500+ Hiring
          <br /> Organizations
        </div>

        {/* <div className="company-slider"> */}
        <Swiper
          slidesPerView={2}
          spaceBetween={7}
          breakpoints={{
            420: {
              slidesPerView: 3,
              spaceBetween: 10,
            },
            768: {
              slidesPerView: 5,
              spaceBetween: 10,
            },
            1024: {
              slidesPerView: 8,
              spaceBetween: 10,
            },
          }}
          centeredSlides={true}
          speed={6000}
          autoplay={{
            delay: 1,
          }}
          loop={true}
          allowTouchMove={false}
          navigation={false}
          modules={[Autoplay]}
          className="mySwiper company-slider"
        >
          {Data.map((data) => (
            <SwiperSlide>
              <HiringOrganizationLayout column={data.items} key={data.id} />
            </SwiperSlide>
          ))}
        </Swiper>
        {/* </div> */}

        {/* <OwlCarousel
          className="owl-theme "
          loop={true}
          nav={false}
          dots={false}
          margin={20}
          items={8}
          responsive={{
            0: {
              items: 3,
            },
            600: {
              items: 5,
            },
            1000: {
              items: 8,
            },
          }}
          autoplay={true}
          autoplaySpeed={5000}
          autoplayHoverPause={false}
        >
          {Data.map((data) => (
            <HiringOrganizationLayout column={data.items} key={data.id} />
          ))}
        </OwlCarousel> */}
      </div>
    </div>
  );
}
export default HiringOrganizations;
